import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {Store, TagState} from './store';

@Injectable({ providedIn: 'root' })
export class TagQuery extends QueryEntity<TagState> {

  constructor(protected store: Store) {
    super(store);
  }

}
